export default function tableOfContents() {
    const article = document.querySelector('.gh-article.has-toc');
    if (!article) return;

    const content = article.querySelector('.gh-content');
    if (!content) return;

    const headings = content.querySelectorAll('h2, h3');
    if (headings.length < 3) return;

    // Ensure all headings have ids
    headings.forEach((heading, i) => {
        if (!heading.id) {
            heading.id = heading.textContent
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/(^-|-$)/g, '') || `heading-${i}`;
        }
    });

    // Build the ToC nav
    const nav = document.createElement('nav');
    nav.className = 'gh-toc';
    nav.setAttribute('aria-label', 'Table of contents');

    const list = document.createElement('ol');
    headings.forEach(heading => {
        const li = document.createElement('li');
        if (heading.tagName === 'H3') {
            li.className = 'gh-toc-h3';
        }
        const a = document.createElement('a');
        a.href = `#${heading.id}`;
        a.textContent = heading.textContent;
        a.addEventListener('click', (e) => {
            e.preventDefault();
            heading.scrollIntoView({ behavior: 'smooth' });
            history.replaceState(null, '', `#${heading.id}`);
        });
        li.appendChild(a);
        list.appendChild(li);
    });

    nav.appendChild(list);
    content.insertAdjacentElement('beforebegin', nav);

    // Highlight active heading with IntersectionObserver
    const links = nav.querySelectorAll('a');
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    links.forEach(link => link.classList.remove('active'));
                    const active = nav.querySelector(`a[href="#${entry.target.id}"]`);
                    if (active) active.classList.add('active');
                }
            });
        },
        {
            rootMargin: '0px 0px -70% 0px',
            threshold: 0,
        }
    );

    headings.forEach(heading => observer.observe(heading));
}
